import { RootState } from '../../RootState';
import selectOptionalSessionContent from './selectOptionalSessionContent';

const selectSessionSessionAccessToken = (state: RootState): string | null => {
  const content = selectOptionalSessionContent(state);
  return content?.tokens?.accessToken ?? null;
};

export default selectSessionSessionAccessToken;
